import { useState, useEffect } from "react";
import {
  Alert,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Container,
  Box,
  Typography,
  Paper
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
    rememberMe: false
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const savedEmail = localStorage.getItem("savedEmail");
    const savedRememberMe = localStorage.getItem("savedRememberMe");

    if (savedRememberMe === "true" && savedEmail) {
      setCredentials((prev) => ({
        ...prev,
        email: savedEmail,
        rememberMe: true,
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const clearAuthStorage = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("role");
  };

  const saveAuth = ({ token, role, rememberMe, email }) => {
    // Önce eski auth verilerini temizle
    clearAuthStorage();

    if (rememberMe) {
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("savedEmail", email);
      localStorage.setItem("savedRememberMe", "true");
    } else {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("role", role);
      localStorage.removeItem("savedEmail");
      localStorage.removeItem("savedRememberMe");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post("/api/auth/admin-login", {
        email: credentials.email,
        password: credentials.password
      });

      saveAuth({
        token: res.data.token,
        role: res.data.role,
        rememberMe: credentials.rememberMe,
        email: credentials.email
      });

      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Giriş başarısız!");
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh"
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: "100%", textAlign: "center" }}>
          <Typography variant="h5" gutterBottom>
            Admin Panel
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <img src="/bilogo.png" alt="Admin Logo" width={150} height={150} />
          </Box>

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="E-posta"
              variant="outlined"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              margin="normal"
            />

            <TextField
              fullWidth
              label="Şifre"
              type="password"
              variant="outlined"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              margin="normal"
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="rememberMe"
                    checked={credentials.rememberMe}
                    onChange={handleChange}
                  />
                }
                label="Beni Hatırla"
              />
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{
                mt: 2,
                fontWeight: "bold",
                fontSize: "1rem",
                padding: "10px"
              }}
            >
              Giriş Yap
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AdminLogin;